import React, { useState, useEffect } from 'react';
import './HeaderClock.css';

/**
 * HeaderClock
 * Displays current date and time in the navbar
 * Updates every second
 */
const HeaderClock = () => {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const formatDate = (date) => {
        const options = {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };
        return date.toLocaleDateString('es-ES', options);
    };

    const formatTime = (date) => {
        return date.toLocaleTimeString('es-ES', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        });
    };

    return (
        <div className="header-clock">
            <div className="header-clock-date">
                <i className="bi bi-calendar3 me-2"></i>
                {formatDate(currentTime)}
            </div>
            <div className="header-clock-time">
                <i className="bi bi-clock me-2"></i>
                {formatTime(currentTime)}
            </div>
        </div>
    );
};

export default HeaderClock;
